import { createContext } from 'react';

interface MobileSidebarContextType {
  isOpen: boolean;
  toggle: () => void;
}

export const MobileSidebarContext = createContext<MobileSidebarContextType>({
  isOpen: false,
  toggle: () => {},
});
